<template>
  <div>
  <nav class="bg-white mx-6">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 2xl:px-8">
      <div class="relative h-16 flex items-center justify-between">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <img class="px-1 h-6 sm:h-8 w-auto" src="mtcontrol.svg"/>
          </div>

        </div>

        <div class="flex-1 px-2 flex justify-center grow 2xl:ml-6 2xl:justify-end">
        </div>

        <div v-if="showLogo" class="px-2 flex justify-right 2xl:ml-6 2xl:justify-end">
          <img class="flex-1 h-6 sm:h-8 inline-flex" :src="pathlogo"/>
        </div>

        <div class="sm:pl-10 flex justify-end px-2 text-gray-300">
          <button v-if="showbutton" class="mr-4 text-3xl hover:text-gray-500" @click="back">
            <i class="w-100 fas fa-arrow-left"></i>
          </button>
          <button class="text-4xl hover:text-gray-500" @click="logout">
            <i class="w-100 fas fa-times"></i>
          </button>
        </div>

      </div>
    </div>
  </nav>

  <header class="bg-white py-4 max-w-7xl mx-6 shadow rounded-b-md">
    <div class="max-w-7xl mx-auto px-6 sm:px-6 2xl:px-8 xl:flex xl:items-center xl:justify-between">
      <div class="flex-1 min-w-0">
        <nav class="flex" aria-label="Breadcrumb">
          <ol role="list" class="flex items-center space-x-4">
            <li>
              <div>
                <a class="sm:text-xl 2xl:text-base font-medium text-gray-500 hover:text-gray-700">{{$store.state.data.plantname}}</a>
              </div>
            </li>
            <li>
              <div class="flex items-center">
                <!-- Heroicon name: solid/chevron-right -->
                <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                </svg>
                <a class="ml-4 sm:text-xl 2xl:text-base font-medium text-gray-500 hover:text-gray-700">{{$store.state.data.line}}</a>
              </div>
            </li>
          </ol>
        </nav>
        <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">{{$store.state.data.devname}}</h1>

        <subtitle-home />

        <info-items-home />
      </div>
    </div>
  </header>


  <div class="grid grid-cols-1 gap-4 m-6">

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 mb-6">
      <template>
       <home-button v-for="button in homebuttons" v-bind:key="button.title" :title="button.title" :blueprintid="button.blueprintid" :validate="button.validate" :badge="button.badge"/>
      </template>
    </div>


    <div v-if="!$store.state.data.unshowdetention">
      <div v-if="$store.state.data.devtype === 'mtflow'" class="bg-white shadow overflow-hidden rounded-md mb-5">
        <a v-on:click="$router.push('/form/createdetention/0')" class="block hover:bg-white px-1">
          <div class="px-4 py-4">
            <div class="px-1 flex items-center justify-between">
              <p class="xl:text-xl 2xl:text-sm font-medium text-red-600">
              Iniciar Detención
              </p>
              <div class="ml-2 flex-shrink-0 flex text-3xl text-red-500">
                <i class="far fa-stop-circle "></i>
              </div>
            </div>
          </div>
        </a>
      </div>

      <detention-list/>

    </div>

    <info-field :field="field" />

    <fin-turno-modal v-if="false" :msg="Hola"/>

    <pending-notifications v-if="pending_items.items !== undefined && pending_items.items.length > 0 && showPendingNotification" :pending_items="pending_items" :toggle=" togglePendingNotification"/>

  </div>

  <div class="mt-8 grid justify-items-center">
    <p class="text-sm text-gray-400">Powered by</p>
    <img class=" px-1 h-5 w-auto" src="mtsolutions_logo.svg"/>
  </div>

</div>
</template>

<script>
import InfoField from '@/components/InfoField'
import InfoItemsHome from '@/components/InfoItemsHome'
import SubtitleHome from '@/components/SubtitleHome'
import DetentionList from '@/components/DetentionList'
import FinTurnoModal from '@/components/FinTurnoModal'
import PendingNotifications from '@/components/PendingNotifications'
import HomeButton from '@/components/HomeButton'
export default {
  name: 'home',
  components: {
    InfoField,
    FinTurnoModal,
    SubtitleHome,
    PendingNotifications,
    HomeButton,
    DetentionList,
    InfoItemsHome
  },
  data() {
    return {
      homebuttons: [],
      showLogo: false,
      showbutton: false,
      pathlogo: '',
      showPendingNotification: false,
      pending_items: {items: []},
      field:  {uri: '/flow/custom/current_info'}
    }
  },
  
  created() {
    this.showButton()
    this.getMenuButtons()
    this.getLogo()
  },

  methods: {
    async showButton(){
        const response = await this.$http.get('flow/custom/formbuttons?method=back')
        if(JSON.stringify(response.data) !== "{}") {
          this.showbutton = true
        }
    },

    async getLogo(){
      const exts = ['svg', 'png', 'jpg']
      for (const ext of exts){
        this.checkIfImageExists(`/pp/${this.$store.state.auth.client}_logo.${ext}`, (exists) => {
          if (exists) {
            console.log(exists);
            this.showLogo = exists
            this.pathlogo = `/pp/${this.$store.state.auth.client}_logo.${ext}`
            return
          } else {
            this.showLogo = exists
          }
        })

      }

    },
    checkIfImageExists(url, callback) {
      const img = new Image();
      img.src = url;

      if (img.complete) {
        callback(true);
      } else {
        img.onload = () => {
          callback(true);
        };

        img.onerror = () => {
          callback(false);
        };
      }
    },
    getMenuButtons: async function () {
      let config = {
        params: this.$store.state.data
      }
      const response = await this.$http.get(`homemenu`, config)
      this.homebuttons = await response.data
    },
    loadNotifications: async function () {
      let config = {
        params: this.$store.state.data
      }
      const response = await this.$http.get(`flow/custom/pending_notifications`, config)
      console.log(response.data)
      this.pending_items = response.data
      if (!this.showPendingNotification){
        this.showPendingNotification = !this.showPendingNotification
      }
    },
    togglePendingNotification(){
      this.showPendingNotification = !this.showPendingNotification
      clearInterval(this.intervalPendingNotifications)
      this.getPendingNotifications()
    },
    getPendingNotifications: function(){
      this.intervalPendingNotifications = setInterval(function () {
        this.loadNotifications();
      }.bind(this), 30000);
    },

    async back() {
      let config = {
        params: {
          blueprint: 'home'
        }
      }
      const response = await this.$http.get('flow/custom/formbuttons?method=back', config)
      this.$router.push(response.data.jump)
      this.$router.go()
    },

    async logout() {
      let config = {
        params: {
          blueprint: undefined
        }
      }
      const response = await this.$http.get('flow/custom/formbuttons?method=logout', config)
      this.$router.push(response.data.jump)
      this.$router.go()
    },
  
  },
  mounted: function () {
    this.loadNotifications();
    this.getPendingNotifications()
  }
}
</script>